import { SchemeBase } from '../../baseBtl/checkout/cart/scheme.class';

export class Scheme extends SchemeBase {
    public is_sales: boolean = false;
    public is_pro: boolean = false;
    public clickCollect: any;
}
